/**
 * Core Spinner — Simple loading indicator.
 */
import React from 'react';
import { CircularProgress, Box } from '@mui/material';
import { cn } from '@/lib/utils';

export interface SpinnerProps {
  size?: number;
  className?: string;
  label?: string;
}

export const Spinner: React.FC<SpinnerProps> = ({ size = 32, className, label }) => (
  <Box display="flex" alignItems="center" justifyContent="center" gap={1} p={2} className={cn(className)}>
    <CircularProgress size={size} />
    {label && <span className="text-sm text-slate-500 dark:text-slate-400">{label}</span>}
  </Box>
);
export default Spinner;
